import { Component, OnInit, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersComponent } from '../filters/filters.component';
import { CommonService } from '../../services';
import { scheduling } from '../../models/scheduling.model';
import { reportingFilter } from '../../models/filter.model';
import { EventListenerService } from '../../services/close-listenenr.service';

@Component({
  selector: 'app-custom-report-edit',
  templateUrl: './custom-report-edit.component.html',
  styleUrls: ['./custom-report-edit.component.css']
})
export class CustomReportEditComponent implements OnInit {

  @ViewChild('filters', { read: ViewContainerRef })
  viewFilter: ViewContainerRef;
  
  title: string = 'Custom Reporting';
  reportType: string = '';
  reportName: string = '';
  customReport: any = null;
  reportingType: string = '';
  report: CustomReport = new CustomReport;

  loadContent = true;

  // Column Variables
  defaultAvailable: Array<string> = [];
  availableCols: Array<string> = [];
  selectedCols: Array<string> = [];

  columns = true;

  listStyle = {
    width: '100%' ,
    height: '100%' ,
    dropZoneHeight: '20px',
  };

  // FILTERS
  currentFilters: Array<reportingFilter> = [];
  // SCHEDULING
  schedule: scheduling = {
    frequency: 'DOWNLOAD NOW'
    , startDate: ''
    , endDate: ''
    , onceDate: ''
    , daysOfWeek: [false, false, false, false, false, false, false]
    , monthSetting: 'DAY'
    , daysOfMonth: [false, false, false, false, false, false, false, false, false, false, 
                    false, false, false, false, false, false, false, false, false, false, 
                    false, false, false, false, false, false, false, false, false, false, 
                    false, false]
    , monthSpecifics: [false, false, false, false, false]
  };

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private commonService: CommonService,
    private resolver: ComponentFactoryResolver,
    private closelistener: EventListenerService
  ) {

    this.closelistener.close.subscribe(value => {
      if (value === 'filters') {
          this.viewFilter.clear();
      }
    });

    this.reportType = this.activeRoute.snapshot.url[this.activeRoute.snapshot.url.length - 1].toString();
    this.defaultAvailable = [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
    ];

    this.selectedCols = [
      '1',
    ];

    this.availableCols = this.defaultAvailable.filter(x => !this.selectedCols.includes(x));

    $('.child-loader').css('overflow-x','auto');
  }

  ngOnInit() {}

  makeSelected = (event: any) => {
    $('.unsortable-list-element').removeClass('activeListElement');
    $(event.currentTarget).addClass('activeListElement');
  }

  // Adds the selected item in the available box to the selected box
  addToSelected = () => {
    let selected = $(".activeListElement");
    let availCurr = '';

    for (let i = 0; i < selected.length; i++)
    {
      availCurr = selected[i].children[0].innerHTML.trim();
      if (!this.selectedCols.includes(availCurr)){
        this.selectedCols.push(availCurr);
        this.availableCols.splice(this.availableCols.indexOf(availCurr), 1);
      }
    }
  }

  addAllToSelected = () => {
    this.selectedCols = this.defaultAvailable;
    this.availableCols = [];
  }

  // Removes the selected item from the selected box to the available box
  removeFromSelected = () => {
    let selected = $(".active");
    let selCurr = '';
    
    for (let i = 0; i < selected.length; i++)
    {
      selCurr = selected[i].children[0].innerHTML.trim().split('<')[0];
      if (!this.availableCols.includes(selCurr)){
        this.availableCols.push(selCurr);
        this.selectedCols.splice(this.selectedCols.indexOf(selCurr), 1);
      }
    }
  }

  removeAllFromSelected = () => {
    this.availableCols = this.defaultAvailable;
    this.selectedCols = [];
  }

  listSorted(event: any){
    this.selectedCols = event;
  }

  openFilterPage = () => {

    if (this.selectedCols.length > 0 && this.reportName != null  && this.reportName !== '')
    {
      if (this.viewFilter.length > 0)
      {
          this.viewFilter.clear();
      }

      let comFactory = null;
      comFactory = this.resolver.resolveComponentFactory(FiltersComponent);
      const component = this.viewFilter.createComponent(comFactory);
      (<FiltersComponent>component.instance).title = 'Report Filters';
      (<FiltersComponent>component.instance).reportType = this.reportType;
      (<FiltersComponent>component.instance).reportName = this.reportName;
      (<FiltersComponent>component.instance).selectedCols = this.selectedCols;
      (<FiltersComponent>component.instance).currentFilters = this.currentFilters;
      (<FiltersComponent>component.instance).schedule = this.schedule;
      (<FiltersComponent>component.instance).customReport = this.customReport;
      (<FiltersComponent>component.instance).reportingType = this.reportingType;

      if (this.reportType === 'edit')
      {
        // (<ReportCreateEditComponent>component.instance).customReport = this.customReport;
        (<FiltersComponent>component.instance).currentFilters = this.currentFilters;
      }
      $('.child-loader').animate({ scrollLeft: 550 }, 800);
    }
    else{
      if (this.reportName == null  || this.reportName === '')
      {
        this.commonService.showError('#reportNameTxtBox', "PLEASE ENTER A REPORT NAME", "right");
      }
      else if (this.selectedCols.length === 0){
        this.commonService.showError('#nextButton', "NO COLUMNS SELECTED", "right");
      }
    }
    
  }


  onLoading(currentLoadingStatus: boolean) {
    
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/reporting');
  }

}

export class CustomReport {
  ReportID: number = -1;
  ReportName: string;
  LoginID: string;
  Columns: string [];
  Filters: string [] = [];
  // These 2 are strings as the are in JSON and will need to be converted
  FiltersJSON: string;
  SchedulingJSON: string;
  ReportType: string = '';
}